import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "long-input q-mx-auto" }

import { computed, onMounted, ref, watch } from "vue";
import { InviteMemberInputsProps, MemberRole, SelectOption } from "@/types";
import { memberRoleOptions } from "@/util";
import { memberApiStore, teamStore } from "@/hooks";
import {
  ProjectInput,
  EmailInput,
  SelectInput,
  TextButton,
  FlexBox,
  MultiselectInput,
  Typography,
  Separator,
} from "@/components/common";


/**
 * Inputs for inviting a new member to a project, team, or organization.
 */
const __default__ = {
  name: "InviteMemberInputs",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    email: {},
    entity: {}
  },
  emits: ["save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const entityIds = ref<string[]>([]);
const userEmail = ref("");
const userRole = ref<MemberRole>();
const emailErrorMessage = ref<string | false>(false);

const roles = computed(() => memberRoleOptions(props.entity.entityType));

const subtitle = computed(
  () =>
    `Invite new members to this ${props.entity.entityType?.toLowerCase()}.
    Members will receive an email to accept the invite.`
);

const submitLabel = computed(
  () => `Invite to ${props.entity.entityType?.toLowerCase() || ""}`
);

const isValidCopy = computed(
  () => entityIds.value.length === 1 && !!userRole.value
);

const isValidEmail = computed(
  () =>
    userEmail.value.length > 0 &&
    !emailErrorMessage.value &&
    entityIds.value.length > 0 &&
    !!userRole.value
);

/**
 * Invites a member to the selected entities.
 */
function handleSaveEmail() {
  entityIds.value.forEach((entityId) => {
    if (!isValidEmail.value || !userRole.value) return;

    memberApiStore.handleInvite(
      {
        email: userEmail.value,
        role: userRole.value,
      },
      {
        entityType: props.entity.entityType,
        entityId,
      },
      {
        onSuccess: () => emit("save"),
      }
    );
  });
}

/**
 * Creates a shareable link to the selected entities.
 */
function handleCopyLink() {
  if (!isValidCopy.value || !userRole.value) return;

  memberApiStore.handleInvite(
    { role: userRole.value },
    {
      entityType: props.entity.entityType,
      entityId: entityIds.value[0],
    }
  );
}

/**
 * Resets the inputs to their default values.
 */
function handleReset() {
  entityIds.value = props.entity.entityId ? [props.entity.entityId] : [];
  userEmail.value = props.email || "";
  userRole.value = undefined;
}

onMounted(handleReset);

watch(
  () => [props.email, props.entity.entityId],
  () => handleReset()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Typography), {
      variant: "subtitle",
      value: "Invite Members"
    }),
    _createVNode(_unref(Separator), { b: "2" }),
    _createVNode(_unref(Typography), {
      secondary: "",
      value: subtitle.value,
      el: "p",
      b: "4"
    }, null, 8, ["value"]),
    _createVNode(_unref(EmailInput), {
      modelValue: userEmail.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userEmail).value = $event)),
      "error-message": emailErrorMessage.value,
      "onUpdate:errorMessage": _cache[1] || (_cache[1] = ($event: any) => ((emailErrorMessage).value = $event)),
      "data-cy": "input-member-email"
    }, null, 8, ["modelValue", "error-message"]),
    _createVNode(_unref(SelectInput), {
      modelValue: userRole.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userRole).value = $event)),
      label: "Role",
      hint: "Required",
      options: roles.value,
      "option-label": (opt) => `${opt.id}: ${opt.name}`,
      "option-value": "id",
      "option-to-value": "",
      class: "q-mb-lg",
      "data-cy": "input-member-role"
    }, null, 8, ["modelValue", "options", "option-label"]),
    (props.entity.entityType === 'PROJECT')
      ? (_openBlock(), _createBlock(_unref(ProjectInput), {
          key: 0,
          modelValue: entityIds.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((entityIds).value = $event)),
          multiple: "",
          hint: "Required"
        }, null, 8, ["modelValue"]))
      : (props.entity.entityType === 'TEAM')
        ? (_openBlock(), _createBlock(_unref(MultiselectInput), {
            key: 1,
            modelValue: entityIds.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((entityIds).value = $event)),
            label: "Teams",
            "option-value": "id",
            "option-label": "name",
            "option-to-value": "",
            options: _unref(teamStore).allTeams,
            hint: "Required"
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true),
    _createVNode(_unref(FlexBox), {
      "full-width": "",
      justify: "between",
      t: "2"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(TextButton), {
          disabled: !isValidCopy.value,
          text: "",
          label: "Copy link",
          icon: "link",
          "data-cy": "button-invite-link",
          onClick: handleCopyLink
        }, null, 8, ["disabled"]),
        _createVNode(_unref(TextButton), {
          disabled: !isValidEmail.value,
          label: submitLabel.value,
          color: "primary",
          "data-cy": "button-invite-member",
          onClick: handleSaveEmail
        }, null, 8, ["disabled", "label"])
      ]),
      _: 1
    })
  ]))
}
}

})